const moduleNameKey = "counterNumber";

export const counterNumberEn = {
  [moduleNameKey]: {
    saveButton: "Save",
    cancelButton: "Cancel",
    titleLabel: "Chart Title",
    titleInputPlaceholder: "Enter chart title",
    machineLabel: "Machine",
    noMachines: "No machines found",
    machinesPlaceholder: "Search machines...",
    nodeLabel: "Node",
    useOpcuaNode: "Use OPCUA node",
    noNodes: "No nodes found",
    nodesPlaceholder: "Search nodes...",
    unitLabel: "Unit",
    noUnits: "No units found",
    unitsPlaceholder: "Search units...",
    targetLabel: "Target Value",
    targetInputPlaceholder: "Enter target value",
    targetInvalid: "Target must be a number",
    thresholdLabel: "Threshold",
    warningLabel: "Warning",
    criticalLabel: "Critical",
    minLabel: "Min Value",
    minInputPlaceholder: "Enter minimum value",
    maxLabel: "Max Value",
    maxInputPlaceholder: "Enter maximum value",
    titleRequired: "Title is required",
    machineRequired: "Pick a machine",
    nodeRequired: "Pick a node",
    lookbackRequired: "Pick a lookback",
    minRequired: "Min value is required",
    maxRequired: "Max value is required",
    warningValueRequired: "Warning value is required",
    criticalValueRequired: "Critical value is required",
    thresholdOrderInvalid: "Critical cannot be lower than Warning",
    scaleInvalid: "Scaling factor must be a number",
  },
};

export const counterNumberPtBr = {
  [moduleNameKey]: {
    saveButton: "Salvar",
    cancelButton: "Cancelar",
    titleLabel: "Título do Gráfico",
    titleInputPlaceholder: "Digite o título do gráfico",
    machineLabel: "Máquina",
    noMachines: "Nenhuma máquina encontrada",
    machinesPlaceholder: "Buscar máquinas...",
    nodeLabel: "Nó",
    useOpcuaNode: "Usar nó OPCUA",
    noNodes: "Nenhum nó encontrado",
    nodesPlaceholder: "Buscar nós...",
    unitLabel: "Unidade",
    noUnits: "Nenhuma unidade encontrada",
    unitsPlaceholder: "Buscar unidades...",
    targetLabel: "Valor Alvo",
    targetInputPlaceholder: "Digite o valor alvo",
    targetInvalid: "O valor alvo deve ser um número",
    thresholdLabel: "Limiar",
    warningLabel: "Aviso",
    criticalLabel: "Crítico",
    minLabel: "Valor Mínimo",
    minInputPlaceholder: "Digite o valor mínimo",
    maxLabel: "Valor Máximo",
    maxInputPlaceholder: "Digite o valor máximo",
    titleRequired: "Título é obrigatório",
    machineRequired: "Selecione uma máquina",
    nodeRequired: "Selecione um nó",
    lookbackRequired: "Selecione um período de leitura",
    minRequired: "Valor mínimo é obrigatório",
    maxRequired: "Valor máximo é obrigatório",
    warningValueRequired: "Valor de aviso é obrigatório",
    criticalValueRequired: "Valor crítico é obrigatório",
    thresholdOrderInvalid: "Crítico não pode ser menor que Aviso",
    scaleInvalid: "O fator de escala deve ser um número",
  },
};

export const counterNumberDe = {
  [moduleNameKey]: {
    saveButton: "Speichern",
    cancelButton: "Abbrechen",
    titleLabel: "Titel des Diagramms",
    titleInputPlaceholder: "Titel des Diagramms eingeben",
    machineLabel: "Maschine",
    noMachines: "Keine Maschinen gefunden",
    machinesPlaceholder: "Maschinen suchen...",
    nodeLabel: "Knoten",
    useOpcuaNode: "OPCUA-Knoten verwenden",
    noNodes: "Keine Knoten gefunden",
    nodesPlaceholder: "Knoten suchen...",
    unitLabel: "Einheit",
    noUnits: "Keine Einheiten gefunden",
    unitsPlaceholder: "Einheiten suchen...",
    targetLabel: "Zielwert",
    targetInputPlaceholder: "Zielwert eingeben",
    targetInvalid: "Zielwert muss eine Zahl sein",
    thresholdLabel: "Schwelle",
    warningLabel: "Warnung",
    criticalLabel: "Kritisch",
    minLabel: "Mindestwert",
    minInputPlaceholder: "Mindestwert eingeben",
    maxLabel: "Höchstwert",
    maxInputPlaceholder: "Höchstwert eingeben",
    titleRequired: "Titel ist erforderlich",
    machineRequired: "Maschine auswählen",
    nodeRequired: "Knoten auswählen",
    lookbackRequired: "Rückblick auswählen",
    minRequired: "Mindestwert ist erforderlich",
    maxRequired: "Höchstwert ist erforderlich",
    warningValueRequired: "Warnwert ist erforderlich",
    criticalValueRequired: "Kritischer Wert ist erforderlich",
    thresholdOrderInvalid: "Kritisch darf nicht kleiner als Warnung sein",
    scaleInvalid: "Der Skalierungsfaktor muss eine Zahl sein",
  },
};

export const counterNumberZhHans = {
  [moduleNameKey]: {
    saveButton: "保存",
    cancelButton: "取消",
    titleLabel: "图表标题",
    titleInputPlaceholder: "输入图表标题",
    machineLabel: "机器",
    noMachines: "未找到机器",
    machinesPlaceholder: "搜索机器...",
    nodeLabel: "节点",
    useOpcuaNode: "使用 OPCUA 节点",
    noNodes: "未找到节点",
    nodesPlaceholder: "搜索节点...",
    unitLabel: "单位",
    noUnits: "未找到单位",
    unitsPlaceholder: "搜索单位...",
    targetLabel: "目标值",
    targetInputPlaceholder: "输入目标值",
    targetInvalid: "目标值必须为数字",
    thresholdLabel: "阈值",
    warningLabel: "警告",
    criticalLabel: "严重",
    minLabel: "最小值",
    minInputPlaceholder: "输入最小值",
    maxLabel: "最大值",
    maxInputPlaceholder: "输入最大值",
    titleRequired: "标题是必填项",
    machineRequired: "选择机器",
    nodeRequired: "选择节点",
    lookbackRequired: "选择回溯时间",
    minRequired: "最小值是必填项",
    maxRequired: "最大值是必填项",
    warningValueRequired: "警告值是必填项",
    criticalValueRequired: "严重值是必填项",
    thresholdOrderInvalid: "严重值不能低于警告值",
    scaleInvalid: "缩放系数必须为数字",
  },
};

export const counterNumberIt = {
  [moduleNameKey]: {
    saveButton: "Salva",
    cancelButton: "Annulla",
    titleLabel: "Titolo del Grafico",
    titleInputPlaceholder: "Inserisci il titolo del grafico",
    machineLabel: "Macchina",
    noMachines: "Nessuna macchina trovata",
    machinesPlaceholder: "Cerca macchine...",
    nodeLabel: "Nodo",
    useOpcuaNode: "Usa nodo OPCUA",
    noNodes: "Nessun nodo trovato",
    nodesPlaceholder: "Cerca nodi...",
    unitLabel: "Unità",
    noUnits: "Nessuna unità trovata",
    unitsPlaceholder: "Cerca unità...",
    targetLabel: "Valore Obiettivo",
    targetInputPlaceholder: "Inserisci il valore obiettivo",
    targetInvalid: "Il valore obiettivo deve essere un numero",
    thresholdLabel: "Soglia",
    warningLabel: "Avviso",
    criticalLabel: "Critica",
    minLabel: "Valore Minimo",
    minInputPlaceholder: "Inserisci il valore minimo",
    maxLabel: "Valore Massimo",
    maxInputPlaceholder: "Inserisci il valore massimo",
    titleRequired: "Il titolo è obbligatorio",
    machineRequired: "Seleziona una macchina",
    nodeRequired: "Seleziona un nodo",
    lookbackRequired: "Seleziona un periodo di osservazione",
    minRequired: "Il valore minimo è obbligatorio",
    maxRequired: "Il valore massimo è obbligatorio",
    warningValueRequired: "Il valore di avviso è obbligatorio",
    criticalValueRequired: "Il valore critico è obbligatorio",
    thresholdOrderInvalid: "Critico non può essere inferiore ad Allarme",
    scaleInvalid: "Il fattore di scala deve essere un numero",
  },
};

export const counterNumberEs = {
  [moduleNameKey]: {
    saveButton: "Guardar",
    cancelButton: "Cancelar",
    titleLabel: "Título del Gráfico",
    titleInputPlaceholder: "Ingrese el título del gráfico",
    machineLabel: "Máquina",
    noMachines: "No se encontraron máquinas",
    machinesPlaceholder: "Buscar máquinas...",
    nodeLabel: "Nodo",
    useOpcuaNode: "Usar nodo OPCUA",
    noNodes: "No se encontraron nodos",
    nodesPlaceholder: "Buscar nodos...",
    unitLabel: "Unidad",
    noUnits: "No se encontraron unidades",
    unitsPlaceholder: "Buscar unidades...",
    targetLabel: "Valor Objetivo",
    targetInputPlaceholder: "Ingrese el valor objetivo",
    targetInvalid: "El valor objetivo debe ser un número",
    thresholdLabel: "Umbral",
    warningLabel: "Advertencia",
    criticalLabel: "Crítico",
    minLabel: "Valor Mínimo",
    minInputPlaceholder: "Ingrese el valor mínimo",
    maxLabel: "Valor Máximo",
    maxInputPlaceholder: "Ingrese el valor máximo",
    titleRequired: "El título es obligatorio",
    machineRequired: "Seleccione una máquina",
    nodeRequired: "Seleccione un nodo",
    lookbackRequired: "Seleccione un período de búsqueda",
    minRequired: "El valor mínimo es obligatorio",
    maxRequired: "El valor máximo es obligatorio",
    warningValueRequired: "El valor de advertencia es obligatorio",
    criticalValueRequired: "El valor crítico es obligatorio",
    thresholdOrderInvalid: "Crítico no puede ser menor que Advertencia",
    scaleInvalid: "El factor de escala debe ser un número",
  },
};

export const counterNumberNl = {
  [moduleNameKey]: {
    saveButton: "Opslaan",
    cancelButton: "Annuleren",
    titleLabel: "Grafiektitel",
    titleInputPlaceholder: "Typ de grafiektitel",
    machineLabel: "Machine",
    noMachines: "Geen machines gevonden",
    machinesPlaceholder: "Machines zoeken...",
    nodeLabel: "Knooppunt",
    useOpcuaNode: "OPCUA-knooppunt gebruiken",
    noNodes: "Geen knooppunten gevonden",
    nodesPlaceholder: "Knooppunten zoeken...",
    unitLabel: "Eenheid",
    noUnits: "Geen eenheden gevonden",
    unitsPlaceholder: "Eenheden",
    targetLabel: "Streefwaarde",
    targetInputPlaceholder: "Typ de streefwaarde",
    targetInvalid: "Streefwaarde moet een getal zijn",
    thresholdLabel: "Drempel",
    warningLabel: "Waarschuwing",
    criticalLabel: "Kritiek",
    minLabel: "Minimumwaarde",
    minInputPlaceholder: "Typ de minimumwaarde",
    maxLabel: "Maximumwaarde",
    maxInputPlaceholder: "Typ de maximumwaarde",
    titleRequired: "Titel is vereist",
    machineRequired: "Kies een machine",
    nodeRequired: "Kies een knooppunt",
    lookbackRequired: "Kies een terugkijkperiode",
    minRequired: "Minimumwaarde is vereist",
    maxRequired: "Maximumwaarde is vereist",
    warningValueRequired: "Waarschuwingswaarde is vereist",
    criticalValueRequired: "Kritieke waarde is vereist",
    thresholdOrderInvalid:
      "Onderste drempelwaarde moet kleiner zijn dan bovenste drempelwaarde",
    scaleInvalid: "De schaalfactor moet een getal zijn",
  },
};

export const counterNumberTr = {
  [moduleNameKey]: {
    saveButton: "Kaydetmek",
    cancelButton: "İptal etmek",
    titleLabel: "Grafik Başlığı",
    titleInputPlaceholder: "Grafik başlığını girin",
    machineLabel: "Makine",
    noMachines: "Hiçbir makine bulunamadı",
    machinesPlaceholder: "Arama makineleri...",
    nodeLabel: "Düğüm",
    useOpcuaNode: "OPCUA düğümü kullan",
    noNodes: "Hiçbir düğüm bulunamadı",
    nodesPlaceholder: "Düğümleri ara...",
    unitLabel: "Birim",
    noUnits: "Birim bulunamadı",
    unitsPlaceholder: "Birimleri arayın...",
    targetLabel: "Hedef Değer",
    targetInputPlaceholder: "Hedef değeri girin",
    targetInvalid: "Hedef bir sayı olmalıdır",
    thresholdLabel: "Eşik",
    warningLabel: "Uyarı",
    criticalLabel: "Kritik",
    minLabel: "Minimum Değer",
    minInputPlaceholder: "Minimum değeri girin",
    maxLabel: "Maksimum Değer",
    maxInputPlaceholder: "Maksimum değeri girin",
    titleRequired: "Başlık gerekli",
    machineRequired: "Bir makine seç",
    nodeRequired: "Bir düğüm seç",
    lookbackRequired: "Bir yeniden inceleme seçin",
    minRequired: "Minimum değer gerekli",
    maxRequired: "Maksimum değer gerekli",
    warningValueRequired: "Uyarı değeri gerekli",
    criticalValueRequired: "Kritik değer gerekli",
    thresholdOrderInvalid: "Kritik Uyarı'dan düşük olamaz",
    scaleInvalid: "Ölçek faktörü bir sayı olmalıdır",
  },
};
